<template>
  <main class="mobile-page about-screen">
    <div class="mobile-screen">
      <header class="mobile-topnav">
        <RouterLink class="mobile-icon-btn" to="/mobile" aria-label="返回首页">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M14.5 5.5 8 12l6.5 6.5" /></svg>
        </RouterLink>
        <span class="mobile-topnav-title">公司简介</span>
        <RouterLink class="mobile-icon-btn" to="/mobile/employee" aria-label="VitaeAI">AI</RouterLink>
      </header>

<!--      <nav class="section-switch" aria-label="公司内容导航">-->
<!--        <a href="#company">公司简介</a>-->
<!--        <a href="#culture">文化理念</a>-->
<!--      </nav>-->

      <section id="company" class="about-section">
        <figure class="visual">
          <img :src="companyProfile.visual.image" :alt="companyProfile.visual.title" loading="eager" />
          <span>AI OPERATING MAP</span>
          <figcaption>{{ companyProfile.visual.title }}</figcaption>
        </figure>

        <span class="mobile-eyebrow">Company · 公司简介</span>
        <h1>{{ companyProfile.title }}</h1>
        <p class="lead">{{ companyProfile.intro }}</p>

        <div class="tag-list">
          <span v-for="tag in companyProfile.tags" :key="tag">{{ tag }}</span>
        </div>

        <div class="mobile-card fact-card">
          <dl class="fact-grid">
            <div
              v-for="(fact, index) in companyProfile.facts"
              :key="fact.label"
              class="fact-item"
              :data-index="String(index + 1).padStart(2, '0')"
            >
              <dt>{{ fact.label }}</dt>
              <dd>{{ fact.value }}</dd>
            </div>
          </dl>
        </div>
      </section>

      <section id="culture" class="about-section culture">
        <figure class="visual">
          <img :src="cultureContent.visual.image" :alt="cultureContent.visual.title" loading="eager" />
          <span>AI · VALUE</span>
          <figcaption>{{ cultureContent.visual.title }}</figcaption>
        </figure>

        <span class="mobile-eyebrow">Culture · 文化理念</span>
        <h1>{{ cultureContent.title }}</h1>
        <p class="lead">{{ cultureContent.lead }}</p>

        <div class="value-list">
          <article v-for="item in cultureContent.highlights" :key="item.label" class="mobile-card value-card">
            <small>{{ item.label }}</small>
            <strong>{{ item.text }}</strong>
            <p>{{ item.desc }}</p>
          </article>
        </div>

        <blockquote class="mobile-card mission">
          <span class="mobile-eyebrow">Our Belief · 我们的相信</span>
          <p>{{ cultureContent.mission }}</p>
        </blockquote>

        <div class="closing">
          <span class="mobile-eyebrow">Our Commitment · 我们的承诺</span>
          <p>{{ cultureContent.closing }}</p>
        </div>
      </section>
    </div>
    <MobileTabbar active="about" />
    <MobileServiceFloating />
  </main>
</template>

<script setup>
import { companyProfile, cultureContent } from '@/data/site'
import MobileTabbar from '@/components/mobile/MobileTabbar.vue'
import MobileServiceFloating from '@/components/mobile/MobileServiceFloating.vue'
</script>

<style scoped>
.about-screen { padding-bottom: calc(104px + env(safe-area-inset-bottom)); }
.section-switch { position:sticky; top:62px; z-index:30; display:grid; grid-template-columns:1fr 1fr; gap:6px; margin:0 -18px 4px; padding:8px 18px; background:rgba(2,5,13,.9); backdrop-filter:blur(12px); }
.section-switch a { min-height:38px; display:flex; align-items:center; justify-content:center; border:1px solid var(--mobile-line); border-radius:11px; color:var(--mobile-muted); font-size:12.5px; font-weight:800; text-decoration:none; background:rgba(255,255,255,.03); }
.section-switch a:active { color:var(--mobile-cyan); border-color:rgba(98,244,214,.35); }
.about-section { padding-top:14px; }
.about-section.culture { margin-top:18px; padding-top:0; border-top:1px solid var(--mobile-line); }
.visual { position:relative; height:210px; margin:0 -18px 18px; overflow:hidden; }
.visual img { width:100%; height:100%; object-fit:cover; filter:saturate(1.06) contrast(1.04); }
.visual::after { content:""; position:absolute; inset:0; background:linear-gradient(180deg,rgba(2,5,13,.1),rgba(2,5,13,.78)); }
.visual span { position:absolute; top:16px; left:20px; z-index:1; color:rgba(98,244,214,.82); font-size:9px; font-weight:800; letter-spacing:.22em; }
.visual figcaption { position:absolute; right:20px; bottom:16px; left:20px; z-index:1; color:var(--mobile-ink); font-size:12px; font-weight:800; line-height:1.55; text-shadow:0 2px 12px rgba(0,0,0,.6); }
h1 { margin:12px 2px 10px; font-size:24px; line-height:1.3; font-weight:900; }
.lead { margin:0 2px 15px; color:var(--mobile-muted); font-size:12px; line-height:1.75; }
.tag-list { display:flex; flex-wrap:wrap; gap:7px; margin-bottom:16px; }
.tag-list span { padding:6px 10px; border:1px solid rgba(98,244,214,.28); border-radius:999px; color:#a8f7e4; font-size:11px; font-weight:700; background:rgba(98,244,214,.07); }
.fact-card { padding:14px; overflow:hidden; border-color:rgba(98,244,214,.16); background:radial-gradient(120% 110% at 100% 0%,rgba(98,244,214,.09),transparent 48%),linear-gradient(160deg,rgba(18,32,52,.82),rgba(7,15,28,.92)); }
.fact-head { display:flex; align-items:center; justify-content:space-between; gap:14px; padding-bottom:12px; border-bottom:1px solid rgba(222,246,255,.1); }
.fact-card .title { margin-bottom:0; }
.fact-count { flex:none; display:grid; place-items:center; width:42px; height:42px; border:1px solid rgba(255,207,106,.26); border-radius:14px; background:linear-gradient(145deg,rgba(255,207,106,.13),rgba(98,244,214,.06)); box-shadow:inset 0 1px 0 rgba(255,255,255,.08); }
.fact-count strong { color:var(--mobile-gold); font-size:15px; font-weight:900; line-height:1; font-variant-numeric:tabular-nums; }
.fact-count span { margin-top:2px; color:var(--mobile-quiet); font-size:7.5px; font-weight:800; letter-spacing:.14em; text-transform:uppercase; }
.fact-grid { display:grid; grid-template-columns:1fr; gap:9px; margin:12px 0 0; }
.fact-item { position:relative; min-width:0; padding:12px 12px 13px; border:1px solid rgba(222,246,255,.09); border-radius:14px; background:linear-gradient(150deg,rgba(255,255,255,.055),rgba(255,255,255,.018)); }
.fact-item::after { content:attr(data-index); position:absolute; top:11px; right:11px; color:rgba(255,207,106,.52); font-size:9.5px; font-weight:900; letter-spacing:.08em; font-variant-numeric:tabular-nums; }
.fact-item dt { max-width:calc(100% - 30px); color:var(--mobile-cyan); font-size:10.5px; font-weight:900; letter-spacing:.06em; line-height:1.4; }
.fact-item dd { margin:8px 0 0; color:var(--mobile-ink); font-size:13px; font-weight:750; line-height:1.62; overflow-wrap:anywhere; }
@media (min-width:390px) {
  .fact-grid { grid-template-columns:repeat(2,minmax(0,1fr)); }
  .fact-item { padding:13px 13px 14px; }
}
.value-list { display:grid; gap:10px; margin-top:16px; }
.value-card small { color:var(--mobile-gold); font-size:10px; font-weight:900; letter-spacing:.12em; }
.value-card strong { display:block; margin:7px 0 6px; font-size:15px; line-height:1.45; font-weight:900; }
.value-card p { color:var(--mobile-quiet); font-size:11.5px; line-height:1.68; }
.mission { margin-top:14px; }
.mission p { margin-top:9px; color:var(--mobile-muted); font-size:12px; line-height:1.75; }
.closing { margin-top:16px; padding:16px; border:1px solid rgba(255,207,106,.24); border-radius:16px; background:linear-gradient(120deg,rgba(255,207,106,.1),rgba(155,140,255,.07)); }
.closing p { margin-top:9px; color:var(--mobile-muted); font-size:12px; line-height:1.75; }
</style>
